import { asyncAction } from '@/lib/action';

export const getDevicesAction = asyncAction('DEVICES/GET_DEVICES');
